import "esbuild-css-modules-plugin-ns-css:src/js/components/checkbox/checkbox.module.css";

import { inject } from "esbuild-css-modules-plugin-ns-js:src/js/components/checkbox/checkbox.module.css:injector.js";
export default new Proxy({
  "checkboxController": "checkbox-module__checkboxController_ev5BdW__1100",
  "checkboxCustom": "checkbox-module__checkboxCustom_ev5BdW__1100",
  "checkboxText": "checkbox-module__checkboxText_ev5BdW__1100",
  "disabled": "checkbox-module__disabled_ev5BdW__1100",
  "multiCheckboxContainer": "checkbox-module__multiCheckboxContainer_ev5BdW__1100"
}, {
  get: function(source, key) {
    inject();
    return source[key];
  }
});
      